import { InjectionToken } from '@angular/core';

export type EnvironmentName = 'local' | 'develop' | 'qa' | 'preprod' | 'production';

/**
 * Contrato compartido por los cinco entornos.
 * Agrega aquí cada variable nueva y complétala en todos los archivos
 * `environment.*.ts`.
 */
export interface Environment {
  name: EnvironmentName;
  production: boolean;
  apiUrl: string;
  appUrl: string;
}

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');
